module.exports = __webpack_public_path__ + "static/media/televox-logo.8291704d.svg";